import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { BounceLoader } from 'halogenium';

import { muiThemeNext } from 'helpers/MUIFiles';
import { MuiThemeProvider } from '@material-ui/core';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import { List } from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';

import { AccentColor } from 'helpers/AccentColorHelper';
import { deepDiver } from 'helpers/utilities';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import { openEditLease } from 'actions/LeaseDetailsActions';
import {
  openLeaseInPersonOverwriteCreator,
  remindRenewalSignatures,
} from 'actions/landlordApplicationsActions';
import { featureEnabled } from 'helpers/ToggleBot';
import { hellosignClient } from 'helpers/hellosignClient';
import env from 'config/constants';
import { getTranslatedString } from 'helpers/i18n';

const RenewalStepper = connect(
  store => ({
    application: store.landlordApplications.application,
    leaseDetails: store.leaseDetails.leaseDetails,
    document_id: store.applicationStatus.document_id,
    signer_id: store.applicationStatus.signer_id,
    clientId: store.landlordSignableDoc.clientId,
  }),
  {
    openEditLease,
    openLeaseInPersonOverwriteCreator,
    remindRenewalSignatures,
  }
)(
  class RenewalStepper extends Component {
    state = { showChargeCard: false, submitting: false, fetchingLeaseDetails: false };

    componentWillUnmount() {
      clearInterval(this.fetchingLeaseInterval);
    }

    signInPerson = () => {
      const leaseDetails = this.props.leaseDetails;
      if (featureEnabled('custom_lease_creator')) {
        this.props.toggleDrawer();
        return hellosignClient.open(leaseDetails.agent_sign_url, {
          clientId: this.props.clientId,
          skipDomainVerification: env.ENV !== 'production',
        });
      }

      this.props.openLeaseInPersonOverwriteCreator(
        leaseDetails.document_uuid,
        leaseDetails.signer_uuid,
        'LEASE_RENEWAL'
      );
    };

    remindRenewalSignatures = () => {
      this.props.remindRenewalSignatures(this.props.leaseDetails.id);
    };

    render() {
      return <Fragment>{this.renderApplicationStepper()}</Fragment>;
    }

    renderApplicationStepper = () => {
      let step = 0;
      if (this.props.leaseDetails.renewal_status === 'pending_landlord_signature') {
        step = 1;
      }

      const renderSteps = this.getSteps().map((label, index) => {
        return (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <p style={{ margin: 0 }}>{this.getStepContent(step)}</p>
              <div>{this.renderStepActions(step)}</div>
            </StepContent>
          </Step>
        );
      });

      return (
        <List style={{ padding: 0 }}>
          <div className="row">
            <MuiThemeProvider theme={muiThemeNext(AccentColor())}>
              <Stepper activeStep={step} orientation="vertical">
                {renderSteps}
              </Stepper>
            </MuiThemeProvider>
          </div>
        </List>
      );
    };

    renderStepActions = step => (
      <div style={{ marginRight: '12px 0' }}>
        {[0, 1].includes(step) && (
          <Fragment>
            <CSSTransitionGroup
              transitionName="create_lease"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              {this.renderSignInPerson(step)}
            </CSSTransitionGroup>
            <CSSTransitionGroup
              transitionName="sign_inperson"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              {this.renderSignInPersonLoading()}
            </CSSTransitionGroup>
          </Fragment>
        )}
      </div>
    );

    setLeaseCreationInterval = leaseID => {
      if (this.fetchingLeaseInterval) return;

      this.fetchingLeaseInterval = setInterval(() => {
        this.props.openEditLease(leaseID).then(response => {
          if (response.value.lease_details.document_status !== 'CREATING_DOCUMENT') {
            clearInterval(this.fetchingLeaseInterval);
          }
        });
      }, 3000);
    };

    renderSignInPersonLoading = () => {
      if (this.props.leaseDetails.document_status !== 'CREATING_DOCUMENT') return;

      this.setLeaseCreationInterval(this.props.leaseDetails.id);

      return (
        <div
          className="row"
          style={{
            marginTop: '21px',
            width: '100px',
            textAlign: 'center',
            marginLeft: '25px',
          }}
        >
          <div
            style={{
              margin: 'auto',
              marginLeft: '21px',
              marginBottom: '10px',
            }}
          >
            <BounceLoader color={AccentColor()} style={{ margin: 'auto' }} />
          </div>
          <p style={{ fontFamily: 'Circular-Bold', marginTop: '5px' }}>Creating Lease</p>
        </div>
      );
    };

    renderSignInPerson = step => {
      if (this.props.leaseDetails.document_status === 'CREATING_DOCUMENT') return;

      let ctaLabel = getTranslatedString('landlordPortal.rentRoll.signInPerson');
      if (this.props.leaseDetails.renewal_status === 'pending_landlord_signature') {
        ctaLabel = getTranslatedString('landlordPortal.rentRoll.signRenewal');
      }

      return (
        <Fragment>
          <RaisedButton
            label={ctaLabel}
            primary
            disabled={
              featureEnabled('custom_lease_creator') && !this.props.leaseDetails.agent_sign_url
            }
            onClick={this.signInPerson}
            style={{
              backgroundColor: AccentColor(),
              color: 'white',
              borderRadius: '8px',
              marginTop: '10px',
            }}
          />
          {step === 0 && (
            <RaisedButton
              primary
              label="Send reminder email"
              style={{
                marginLeft: '0.5rem',
                backgroundColor: AccentColor(),
                color: 'white',
                borderRadius: '8px',
                marginTop: '10px',
              }}
              onClick={this.remindRenewalSignatures}
            />
          )}
        </Fragment>
      );
    };

    getSteps = () => {
      return ['Pending Signature', 'Sign Renewal'];
    };

    getFirstStepMessaging = () => {
      let messaging = (
        <span>
          An email has been sent to <TenantResidentVerbiageHelper />s with emails to complete the
          renewal online. You may also click below to sign the renewal in-person if your{' '}
          <TenantResidentVerbiageHelper />s are present.
        </span>
      );
      if (!deepDiver(this.props.leaseDetails, 'using_resident_portal')) {
        return (
          <span>
            Once your <TenantResidentVerbiageHelper />s are present, click below to sign and
            complete the renewal process.
          </span>
        );
      }
      return messaging;
    };

    getStepContent = step => {
      switch (step) {
        case 0:
          return this.getFirstStepMessaging();
        case 1:
          return 'Complete the renewal process by signing below. Click the button below to sign.';
        default:
          return null;
      }
    };
  }
);

export default RenewalStepper;
